import React from 'react';
import { Text, TextProps } from '@opendoor/bricks/core';
import { css } from '@emotion/react';
import { breakpoints } from '@opendoor/bricks/theme/eero';

export interface AddressDisplayProps {
  street?: string | null;
  city?: string | null;
  state?: string | null;
  postalCode?: string | null;
  unitNumber?: string | null;
  latitude?: number | null;
  longitude?: number | null;
}

const hiddenLarge = css`
  @media (min-width: ${breakpoints[2]}px) {
    display: none;
  }
`;

const AddressDisplay: React.FC<AddressDisplayProps & TextProps> = ({
  street,
  city,
  state,
  postalCode,
  unitNumber,
  ...textProps
}) => {
  return (
    <Text as="h1" fontSize="s3" fontWeight="bold" mb="0" {...textProps}>
      {street && `${street}`}
      {unitNumber && ` #${unitNumber}`} <br css={hiddenLarge} />
      {city && `${city}, `}
      {state && `${state} `} {postalCode}
    </Text>
  );
};

export default AddressDisplay;
